import { DeleteIcon, LucideDelete } from "lucide-react";
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from "reactstrap";

interface Props {

    isOpen: boolean;

    groupName: string;

    toggle: () => void;

    onDelete: () => void;

    loading?: boolean;

}

const DeleteGroupModal = ({
    isOpen,
    groupName,
    toggle,
    onDelete,
    loading = false
}: Props) => {

    return (

        <Modal
            isOpen={isOpen}
            toggle={toggle}
            centered
        >

            <ModalHeader toggle={toggle} style={{backgroundColor:"black", color:"white"}}>
                Delete Group
            </ModalHeader>

            <ModalBody>

                Are you sure you want to delete

                <strong> {groupName}</strong>?

                <br />
                <br />

                This action cannot be undone.

            </ModalBody>

            <ModalFooter>

                <Button
                    color="secondary"
                    onClick={toggle}
                    disabled={loading}
                >
                    Cancel
                </Button>

                <Button
                    color="danger"
                    onClick={onDelete}
                    disabled={loading}
                >
                    {loading
                        ? "Deleting..."
                        : "Delete"}
                </Button>

            </ModalFooter>

        </Modal>

    );

};

export default DeleteGroupModal;